"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const module_1 = require("../core/module");
class CategoryModule extends module_1.default {
    constructor() {
        super(...arguments);
        this.endpoint = "/api/v1/fields_of_activity/";
        this._canPaginate = true;
    }
    async list(params = {}, page = 1) {
        const results = (await this._list(page, params));
        return results;
    }
    async activities() {
        const { data } = await this.axiosInstance.get("/api/v2/activities/");
        return data;
    }
}
exports.default = CategoryModule;
//# sourceMappingURL=categories.js.map